import styled from 'styled-components'

export const PopupContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.5rem; /* mt-2 */
  width: 100%;
  max-width: 24rem; /* max-w-sm */
  background-color: white;
  padding: 1rem; /* p-4 */
  box-shadow:
    0 20px 25px -5px rgb(0 0 0 / 0.1),
    0 8px 10px -6px rgb(0 0 0 / 0.1); /* shadow-xl */
  border-radius: 0.5rem; /* rounded-lg */
  border: 1px solid #e5e7eb; /* border-gray-200 */
  z-index: 10;

  @media (min-width: 640px) {
    max-width: 28rem; /* sm:max-w-md */
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem; /* mb-4 */
`

export const NavButton = styled.button.attrs({
  type: 'button',
})`
  padding: 0.5rem; /* p-2 */
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.15s;
  &:hover {
    background-color: #f3f4f6; /* hover:bg-gray-100 */
  }
`

export const MonthYearDisplay = styled.div`
  font-size: 1.125rem; /* text-lg */
  font-weight: 600; /* font-semibold */
  color: #111827; /* text-gray-900 */
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr)); /* grid-cols-7 */
  text-align: center;
`

export const DayOfWeek = styled.div`
  font-size: 0.75rem; /* text-xs */
  font-weight: 500; /* font-medium */
  color: #6b7280; /* text-gray-500 */
  text-transform: uppercase;
`
